import { Flex, SystemStyleObject } from "@chakra-ui/react";
import { useTableBoxContext } from "shared/components/table/box/TableBoxContext";

export interface TableBoxStatsProps {
  sx?: SystemStyleObject;
}

export const TableBoxStats: React.FC<
  React.PropsWithChildren<TableBoxStatsProps>
> = ({ children, sx }) => {
  const { isFullScreen } = useTableBoxContext();
  if (isFullScreen) {
    return null;
  }
  return (
    <Flex
      className="mb-tablebox-stats"
      px="24px"
      py="16px"
      whiteSpace="nowrap"
      sx={{
        "& .chakra-stat__group": {
          gap: "48px",
        },
        ...sx,
      }}
    >
      {children}
    </Flex>
  );
};
